import { orderBy, isNumber, head } from 'lodash';
import moment from 'moment';
import { ReactComponent as ClinicalEventsIcon } from '../../../../assets/icons/activitesIcon.svg';
import {
  eventNameOptions,
  assistanceLvlOptions,
} from '../../ClinicalEvents/events-fields-options';
import useRtmEventsService from '../../ClinicalEvents/service';

export default function useClinicalEvent(patientUuid: string) {    
  const { data } = useRtmEventsService(patientUuid);
  const orderedClinicalEvents = orderBy(data, 'serviceTime', 'asc');

  return orderedClinicalEvents.map((event) => {
    const currentVersion = head(event.versions);
    const eventName = eventNameOptions?.find(
      (option) => option.value === currentVersion?.eventName
    )?.label;

    return {
      name: eventName,
      date: event.serviceTime,
      icon: ClinicalEventsIcon,
      description: [
        {
          name: 'Level of assistance',
          description: assistanceLvlOptions?.find(
            (option) => option?.value === currentVersion?.assistanceLvl
          )?.label,
        },
        ...(currentVersion?.comment
          ? [{ name: 'Comment', description: currentVersion.comment }]
          : []),

        ...(isNumber(currentVersion?.durationInSeconds)
          ? [
              {
                name: 'Duration',
                description: moment
                  .duration(currentVersion?.durationInSeconds, 'seconds')
                  .format('mm [min]'),
              },
            ]
          : []),
      ],
      isToHideEditIcon: true,
      id: event.uuid,
    };
  });
}
